import React from 'react';
import image from './../../images/image.jpg'
import './../../style/AboutUs.css';
import Article from './Article';

class AboutUs extends React.Component {

    render() {
        return (
            <div className="section-aboutus">
                <Article/>
                <div className="about-us">
                    <div className="introduce">
                        <h3>OUR story</h3>
                        <p>2018.04.11 Meongca iOS app Launches</p>
                    </div>
                    <div className="picture">
                        <div className="pic">
                            <img src={image} alt="img"/>
                            <div className="middle">
                                <div className="text">
                                    <p>Go.rani</p>
                                    <p>윤수연</p>
                                </div>
                            </div>
                        </div>
                        <div className="pic">
                            <img src={image} alt="img"/>
                            <div className="middle">
                                <div className="text">
                                    <p>Cafielo</p>
                                    <p>이준원</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}

export default AboutUs;


// WEBPACK FOOTER //
// ./src/components/container/AboutUs.js